import React, { useState } from 'react';
import Papa from 'papaparse';
import { ReactComponent as CsvFile } from "../images/csv_file.svg";

// Checks that all fields of the first record have values, assumes the file is good if it does
function CSVTester(responses) {
  let checkIndexes = [9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63]
  checkIndexes.forEach(index => {
      if (responses[0][index] === "" || responses[0][index] === undefined) {throw "CSV Error";};
  });
  // if (responses[0][64] != "" || responses[0][64] != undefined) {throw "CSV Error";};
}

// Parses and returns data
// Returns an array that contains the first 2 rows of data (the questions), and the rest of the data
function parseCSV(file) {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: false,
      dynamicTyping: true,
      complete: (result) => {
        const questions = result.data.slice(0,2);
        const responses = result.data.slice(2,-1);
        resolve([questions, responses]);
      },
      error: (error) => {
        reject(error);
      },
    });
  });
}

// Takes CSV file and returns its parsed data, split into questions and responses
function CSVHandler({ onCSVDataParsed }) {
  const [errorMessage, setErrorMessage] = useState(false);
  const handleFileUpload = event => {
    setErrorMessage(false);
    const file = event.target.files[0];
    if (file) {
      parseCSV(file)
        .then((data) => {
          CSVTester(data[1])
          // console.log(data[1]);
          onCSVDataParsed(data);
        })
        .catch(error => {
          setErrorMessage("Error: CSV File is invalid.")
          console.log(error)
        })
    }
  };



  return (
    <div className="csv-upload">
      <div style={{width: "30%"}}>
      <span className='info'>Export survey data from SurveyMonkey: 
      Survey &rarr; Analyze Results &rarr; Save As &rarr; Export File &rarr;
      All Responses Data &rarr; CSV &rarr; Export</span>
      </div>  
      <CsvFile height={200} width={200} />

      <label htmlFor="file-upload" className="Primary-button-large">
        Upload File
      </label>
      <input
        id="file-upload"
        type="file"
        accept=".csv"
        onChange={handleFileUpload}
      />

      {errorMessage && <span style={{color: "#F00", fontSize: "2.5rem"}}>{errorMessage}</span>}
    </div>
  );
}

export default CSVHandler;
